import { appUrl } from "@src/cloud-connect/feature-toggles/feature-toggles";
import navigateTo from "@src/routes/navigator";
import { Route } from "@src/routes/routes";
import TokensExpiredError from "../errors/tokens-expired-error";
import { buildAuthenticationBody } from "../util/build-authentication-body";
import { buildAuthenticationHeaders } from "../util/build-authentication-headers";

export const checkIfScanIsFinished = (scanId) => {
  return fetch(`${appUrl()}/api/scans/check-if-scan-is-finished`, {
    method: "POST",
    headers: buildAuthenticationHeaders(),
    body: JSON.stringify({
      ...buildAuthenticationBody(),
      scanId,
    }),
  })
    .then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const json = await res.json();
        if (json.message === "Refresh Token is expired") {
          throw new TokensExpiredError("All Tokens Expired");
        } else {
          throw new Error("Server Responded with 500");
        }
      }
    })
    .then((data) => {
      if (data !== undefined) {
        return data;
      }
    })
    .catch((err) => {
      if (err instanceof TokensExpiredError) {
        navigateTo(Route.TOKENS_EXPIRED_ERROR);
      } else {
        navigateTo(Route.SERVER_ERROR);
      }
    });
};
